/**
 * @group Enums
 * 
 * @summary
 * <blockquote>Health record upload status lifecycle states.</blockquote>
 * 
 * @example
 * ```typescript
 * const status: UploadStatus = UPLOAD_STATUSES.SUCCESS;
 * // 'success'
 * ```
 */
export const UPLOAD_STATUSES = {
  PENDING: 'pending',
  IN_PROGRESS: 'in_progress',
  SUCCESS: 'success',
  FAILED: 'failed',
  RETRYING: 'retrying',
} as const;
